module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fe5263e13c7d0dc4834ac8e648a88fbe.png";